import { ThemeProvider } from '@sparemin/blockhead';
import React from 'react';
import SteppedModal from 'components/SteppedModal';
import { useSocialShareModal } from './SocialShareModalContext';
import { useSocialSharePlatform } from './SocialSharePlatforms';
import useSocialShareConnectedModal from './useSocialShareConnectedModal';
import { socialShareModalBlock as block } from './utils';

export type SocialShareModalContentsProps = {};

const SocialShareModalContents: React.FC<SocialShareModalContentsProps> = () => {
  const { show, onHide, onExited } = useSocialShareConnectedModal();

  const { modalRef } = useSocialShareModal();
  const { platformAlias, steps, defaultStep } = useSocialSharePlatform();

  return (
    <ThemeProvider theme="dark">
      <SteppedModal
        {...{ show, steps, defaultStep, onHide, onExited }}
        ref={modalRef}
        title={`Publish to ${platformAlias}`}
        baseClassName={block()}
      />
    </ThemeProvider>
  );
};

export default SocialShareModalContents;
